import {useEffect, useRef, useState} from 'react';

/**
 * Hook для получения ширины и высоты экрана (под экраном понимается - Layout viewport
 * https://developer.mozilla.org/en-US/docs/Glossary/Layout_viewport).
 *
 * Если использовать css media-запросы для отображения отдельных компонентов для мобильной и десктопной версий,
 * то оба компонента будут отрисованы, и только после этого один из них будет скрыт (например, с помощью display: none).
 * Если такое поведение нежелательно, используйте данный hook.
 * @returns {{width: number, height: number}} объект с шириной и высотой экрана
 */
export default function useWindowWidth(widthBreakpoint) {
  const [windowWidth, setWindowWidth] = useState(window.innerWidth);

  const previousWidth = useRef(null);

  useEffect(() => {
    function handleChange() {
      setWindowWidth(window.innerWidth);
    }

    function handleChangeWithBreakpoint(e) {
      const currentWidth = e.target.innerWidth;
      if (!previousWidth.current ||
          (currentWidth >= widthBreakpoint && previousWidth.current < widthBreakpoint)
          || (currentWidth <= widthBreakpoint && previousWidth.current > widthBreakpoint)) {

        handleChange();
      }
      previousWidth.current = currentWidth;
    }

    const resizeListener = (e) => {
      if (!widthBreakpoint) {
        handleChange();
      } else {
        handleChangeWithBreakpoint(e);
      }
    }
    window.addEventListener('resize', resizeListener);
    return () => window.removeEventListener('resize', resizeListener);
  }, []);

  return windowWidth;
}